import React, { useContext } from 'react';
import { Question } from '../Question';
import FaqContext from '../../../../contexts/FAQContext';
import { Accordion, AccordionList, LinkTitle, CollapseItem, Icon } from './styles';

export const QuestionsGroup = ({ data: { name, questions, key } }) => {
  const { isOpen, toggleOpen } = useContext(FaqContext);
  const openCollapsed = isOpen === key;

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      toggleOpen(event);
    }
  };
  const handleMouseDown = event => {
    event.preventDefault();
    toggleOpen(event);
  };

  return (
    <Accordion xs="12" className="py-2 px-2">
      <LinkTitle
        className={`${openCollapsed ? 'active' : ''} py-1`}
        data-index={key}
        onMouseDown={handleMouseDown}
        tabIndex="0"
        aria-label={`category: ${name}`}
        onKeyPress={handleKeyPress}
        role="button"
        aria-expanded={openCollapsed}
        aria-controls={`${name}`.split(' ').join('_')}
      >
        <Icon data-index={key} className="dds__icons">
          〉
        </Icon>
        <u>{name}</u>
      </LinkTitle>
      <CollapseItem isOpen={openCollapsed}>
        <AccordionList className="py-1 pl-0" id={`${name}`.split(' ').join('_')}>
          {questions
            .sort((a, b) => {
              if (a.order < b.order) return -1;
              if (a.order > b.order) return 1;
              return 0;
            }).map(question => (
              <Question key={`${question.order}`} data={question} />
            ))
          }
        </AccordionList>
      </CollapseItem>
    </Accordion>
  );
};
